import React from "react";
import { FaEnvelopeOpenText } from "react-icons/fa"; // 편지 아이콘 추가

const FeedBackSection = () => {
  return (
    <section className="bg-black text-white py-16 w-full flex justify-center items-center">
      <div className="bg-white text-black max-w-2xl mx-auto p-8 rounded-lg shadow-lg text-center border border-gray-200">
        {/* 편지지 느낌의 아이콘 */}
        <div className="text-6xl text-blue-500 mb-4 flex justify-center">
          <FaEnvelopeOpenText />
        </div>

        <h2 className="text-3xl font-bold mb-4">당신의 소중한 의견을 기다립니다!</h2>
        
        <p className="text-gray-700 leading-relaxed mb-6">
          매드키워드는 사용자 여러분의 의견을 소중하게 생각합니다.  
          더 나은 서비스로 발전할 수 있도록 개선 사항이나 협업 아이디어를 공유해 주세요!  
          여러분의 피드백이 직접 반영됩니다. 💡
        </p>

        {/* 구글 설문지 링크 */}
        <a 
          href="https://forms.gle/nahyZ3WxYhpdk32v8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-blue-500 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-blue-600 transition"
        >
          ✨ 의견 보내기 (구글 설문지)
        </a>
        
        <p className="text-gray-500 text-sm mt-4">
          빠르게 1분이면 작성할 수 있어요! 😊
        </p>
      </div>
    </section>
  );
};

export default FeedBackSection;
